import React from "react";
import { Link, useLocation } from "react-router-dom";
import resume from "../resume.pdf";

export function NavBar() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <nav
      aria-label="Primary navigation"
      className={`site-nav ${
        isHome ? "site-nav--home" : "site-nav--editorial"
      }`}
    >
      <div className="site-nav__inner">
        <Link to="/" className="site-nav__name">
          Jacob Marthaller
        </Link>
        <div className="site-nav__links">
          <Link to="/blog">Writing</Link>
          <a href={resume} target="_blank" rel="noopener noreferrer">
            Resume
          </a>
          <a
            href="https://github.com/jmarthaller"
            aria-label="Jacob Marthaller on GitHub"
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/jacob-marthaller/"
            aria-label="Jacob Marthaller on LinkedIn"
          >
            LinkedIn
          </a>
          <a href="/#contact">Contact</a>
        </div>
      </div>
    </nav>
  );
}
